import { FC, useState, useEffect } from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import { Box, Typography } from '@mui/material';
import { ICustomPageSection, IDropdownResponse } from '../../../models';
import { getCustomPageTypes } from '../../../fetch';
import { EditableSection } from './EditableSection';

// a little function to help us with reordering the result
const reorder = (list: ICustomPageSection[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  // update all of the items array sortOrder to be unique
  return result.map((r, i) => ({
    ...r,
    sortOrder: i + 1
  }));
};

interface ISortableList {
  sections: ICustomPageSection[];
  sectionTypes: IDropdownResponse[];
  setSections: (val: ICustomPageSection[]) => void;
  customPageId: number;
}

const SortableList = SortableContainer(({ sections, setSections, sectionTypes, customPageId }: ISortableList) => {
  return (
    <div>
      {sections &&
        sections.length > 0 &&
        sections.map((item, index) => (
          <EditableSection
            sectionTypes={sectionTypes}
            setSections={setSections}
            sections={sections}
            key={`${index}`}
            itemIndex={index}
            index={index}
            customPageId={customPageId}
            section={item}
          />
        ))}
      {(!sections || sections.length === 0) && (
        <Box padding="1rem" display="flex" border="1px solid rgba(0, 0, 0, 0.12)" alignItems="center" flexDirection="column" height="15rem" justifyContent="center">
          <Typography>No sections created, click the "Add Section" button below to start creating your content.</Typography>
        </Box>
      )}
    </div>
  );
});

interface IEditSections {
  sections: ICustomPageSection[];
  setSections: (val: ICustomPageSection[]) => void;
  customPageId: number;
}

export const EditSections: FC<IEditSections> = ({ sections, setSections, customPageId }) => {
  const [sectionTypes, setSectionTypes] = useState<IDropdownResponse[]>([]);
  const onSortEnd = ({ oldIndex, newIndex }) => {
    const items: any[] = reorder(sections, oldIndex, newIndex);
    setSections(items);
  };

  const fetchCustomSectionTypes = async () => {
    try {
      const res = await getCustomPageTypes();
      setSectionTypes(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCustomSectionTypes();
  }, []);
  return (
    <>
      <SortableList sectionTypes={sectionTypes} useDragHandle sections={sections} setSections={setSections} onSortEnd={onSortEnd} customPageId={customPageId} axis="y" />
    </>
  );
};
